import cx from 'classnames';
import React from 'react';

import * as styles from './ContactBox.module.css';

const ContactBox = ({
	children,
	align = 'center',
	className = '',
}: {
	children: React.ReactNode;
	align?: 'left' | 'center' | 'right';
	className?: string;
}) => {
	return (
		<div className={styles.box}>
			<div
				className={cx(styles.content, className, {
					[styles[`${align}Align`]]: align,
				})}
			>
				{children}
			</div>
		</div>
	);
};

export default ContactBox;
